import React from 'react';

// Blockquote rendering extracted from NodeRenderer.
// Receives a renderNode callback from the parent to avoid circular imports.
const Blockquote = ({node, idx, inTable = false, inListItem = false, renderNode}) => {
    if (!node) return null;
    const key = `node-${idx}`;

    const getClassification = (n) => n?.attrs?.classification_access || 'U';

    // helper: find first child (paragraph or heading) that has content to receive prefix
    const findFirstPrefixTargetIndex = (children = []) => {
        for (let i = 0; i < (children?.length || 0); i++) {
            const c = children[i];
            if ((c?.type === 'paragraph' || c?.type === 'heading') && (c?.content?.length > 0)) {
                return i;
            }
        }
        return -1;
    };

    const firstIdx = findFirstPrefixTargetIndex(node?.content);
    const cls = (node?.content?.length > 0) ? `(${getClassification(node)})` : undefined;

    return (
        <blockquote
            key={key}
            style={{
                borderLeft: '4px solid rgba(0,0,0,0.12)',
                margin: inTable ? 0 : '12px 0',
                padding: '8px 12px',
                background: 'rgba(0,0,0,0.02)'
            }}
        >
            {(node.content || []).map((c, i) => (
                renderNode(c, `${key}-b-${i}`, {inTable, inListItem, prefixText: i === firstIdx ? cls : undefined})
            ))}
        </blockquote>
    );
};

export default Blockquote;

